<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div v-if="!modoEdicao">
        <!-- Tabela -->
        <div v-if="lsDados.length > 0">
            <div class="table-wrapper row-space"><table>
                <thead><tr>
                    <th>OS</th>
                    <th>Nome/Identificação</th>
                    <th>Equipamento</th>
                    <th>Placa</th>
                    <th>Fornecedor</th>
                    <th>Abertura</th>
                </tr></thead>

                <tbody><tr v-for="(obj, index) in lsDados" :key="obj.id" @click="editarCadastro(obj)"
                    :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}"
                >
                    <td class="col-width-char10 right">{{ Funcoes.formatInteger(obj.cdos) }}</td>
                    <td>{{ obj.nmos }}</td>
                    <td class="col-width-char30">{{ obj.nmequipamento }}</td>
                    <td class="col-width-char10 center">{{ obj.placa }}</td>
                    <td class="col-width-char30">{{ obj.nmfornecedor }}</td>
                    <td class="col-width-date center">{{ Funcoes.formatDateFromJson(obj.dtabertura) }}</td>
                </tr></tbody>
            </table></div>

            <div v-if="showPagination" class="pagination">
                <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
                <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
                <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
            </div>
        </div>

        <div class="row-end">
            <button class="btn-small" @click="closeForm()">Fechar</button>
        </div>
    </div>


    <div v-if="modoEdicao">
        <div class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item-char10">
                    <label class="label-caption">OS</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatInteger(osView.cdos) }}</div>
                </div>

                <div class="form-item-char10">
                    <label class="label-caption">Abertura</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(osView.dtabertura) }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Nome/Descrição</label>
                    <div class="field-label">{{ osView.nmos }}</div>
                </div>
                
                <div class="form-item-char40">
                    <label class="label-caption">Equipamento</label>
                    <div class="field-label">{{ osView.nmequipamento }}</div>
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item">
                    <AnexoUploadField
                        ref="uploaderRef"
                        :label="'Anexar orçamento:'"
                        :maxSizeMB="20"
                    />
                </div>
            </div>
            

            <div v-if="!modoEdicaoAnexado" class="row-end">
                <button class="btn-confirm" @click="analisarAnexo">Anexar/Analisar</button>
                <button class="btn-cancel" @click="cancelEdicao">Cancelar</button>
            </div>


            <!-- FLUXO ORÇAMENTO -->
            <div v-if="modoEdicaoAnexado" class="row row-space">
                <div class="form-item-char15">
                    <label class="label-caption">Nro Orçamento</label>
                    <input type="text" class="input-right" v-model="edOrcNroDoc" v-number maxlength="9" />
                </div>
                
                <div class="form-item-data">
                    <label class="label-caption">Data</label>
                    <input type="date" v-model="edOrcDtDoc" />
                </div>
                
                <div class="form-item-char30">
                    <label class="label-caption">Valor (R$)</label>
                    <input type="text" class="input-right" v-model="edOrcValor" v-decimal maxlength="15" />
                </div>
                
                <div class="form-item">
                    <label class="label-caption">Nome Contato</label>
                    <input type="text" v-model="edOrcNmContato" maxlength="100" v-uppercase />
                </div>
            </div>
            

            <div v-if="modoEdicaoAnexado" class="row-end">
                <button class="btn-confirm" @click="abrirModalEncerrar">Salvar</button>
                <button class="btn-cancel" @click="cancelEdicao">Cancelar</button>
            </div>
        </div>
    </div>


    <div v-if="orcamentoPreview?.ok" class="orc-preview">
        <div class="orc-header">
            <div>
                <strong>Orçamento:</strong> #{{ orcamentoPreview.orcamento.numero }}
            </div>
            <div>
                <strong>Data:</strong> {{ orcamentoPreview.orcamento.data }}
            </div>
            <div>
                <strong>Placa:</strong> {{ orcamentoPreview.orcamento.placa }}
            </div>
            <div>
                <strong>KM:</strong> {{ orcamentoPreview.orcamento.quilometragem }}
            </div>
            <div class="orc-veiculo">
                <strong>Veículo:</strong> {{ orcamentoPreview.orcamento.veiculo }}
            </div>
        </div>

        <div class="orc-table-wrap">
            <table class="orc-table">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Operações</th>
                        <th>Horas</th>
                        <th>Qtd</th>
                        <th>Descrição</th>
                        <th>Código</th>
                        <th class="num">Valor</th>
                        <th class="num">Desc.</th>
                        <th class="num">Líquido</th>
                    </tr>
                </thead>

                <tbody>
                    <tr
                        v-for="item in orcamentoPreview.itens"
                        :key="item.ordem"
                        :class="{ 'linha-alerta': !item.descricao }"
                    >
                        <td>{{ item.ordem }}</td>
                        <td>{{ item.operacoes }}</td>
                        <td>{{ formatDecimal(item.tempo) }}</td>
                        <td>{{ formatDecimal(item.qtd) }}</td>

                        <td>
                            <input
                                v-model="item.descricao"
                                class="orc-input-desc"
                                :class="{ 'input-alerta': !item.descricao }"
                                placeholder="Descrição não identificada"
                            />
                        </td>

                        <td>
                            <input
                                v-model="item.codigo"
                                class="orc-input-cod"
                                placeholder="-"
                            />
                        </td>

                        <td class="num">{{ formatMoney(item.valor) }}</td>
                        <td class="num">{{ formatMoney(item.desconto) }}</td>
                        <td class="num">{{ formatMoney(item.valorLiquido) }}</td>
                    </tr>
                </tbody>

                <tfoot>
                    <tr>
                        <td colspan="8" class="num"><strong>Total peças/produtos</strong></td>
                        <td class="num"><strong>{{ formatMoney(totalItens) }}</strong></td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>


    <ConfirmModal ref="confirmModal" />
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import AnexoUploadField from '@/components/fields/AnexoUploadField.vue';
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit = defineEmits(['close']);

const confirmModal = ref(null)
const isLoading = ref(false);
const lsDados = ref([]);
const modoEdicao = ref(false);
const modoEdicaoAnexado = ref(false);
const msgAlerta = ref(null);

const orcamentoPreview = ref(null);
const osView = ref({});

const edOrcNroDoc = ref(null);
const edOrcDtDoc = ref(null);
const edOrcValor = ref(null);
const edOrcNmContato = ref(null);

const uploaderRef = ref(null); //01-02-2026 TESTE NOVO COMPONENTE

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);


const totalItens = computed(() => {
    if (!orcamentoPreview.value?.itens) return 0;

    return orcamentoPreview.value.itens.reduce((total, item) => {
        return total + Number(item.valorLiquido || 0);
    }, 0);
})


function formatMoney(value) {
    return Number(value || 0).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    });
}


function formatDecimal(value) {
    return Number(value || 0).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}


async function abrirModalEncerrar(){
    const confirmado = await confirmModal.value.show({
        message: "Confirma anexo do orçamento e encerramento da etapa?",
        confirmText: 'Sim',
        cancelText: 'Não'
    })
    if (confirmado){salvarEncerraDigitacao()}
}


async function analisarAnexo(){
    msgAlerta.value=null;
    if (!uploaderRef.value?.hasFile()){
        msgAlerta.value="Nenhum arquivo selecionado";
        return;
    }

    try{
        const file = uploaderRef.value.getFile();

        const response = await Api.genericPostFormData(
            '/frota/orcamentos/importar-preview',
            file);

        orcamentoPreview.value = response;

    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


function cancelEdicao(){
    if (lsDados.value.length > 0){
        msgAlerta.value=null;
        modoEdicao.value = false;
    }else{
        closeForm();
    }
}


function closeForm() { emit('close'); }


function editarCadastro(obj) {
    osView.value = obj;
    modoEdicao.value=true;
}


function updatePaginatedData() {
    const startIndex = (currentPage.value - 1) * globalStore.itensPorPagina;
    const endIndex = (startIndex + globalStore.itensPorPagina);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}


async function lerDados() {
    try {
        msgAlerta.value = null;
        isLoading.value = true;

        const payload = {
            idmunicipio: globalStore.idmunicipio,
            intparam1: 4,
            idlogin: globalStore.idlogin,
        };

        const req = await Api.genericPost('/dados/manut_os', payload);
        lsDadosMain.value = req || [];
        currentPage.value = 1;
        showPagination.value = (lsDadosMain.value.length > globalStore.itensPorPagina);
        updatePaginatedData();
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


async function salvarEncerraDigitacao(){
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const payload = {
            id: osView.value.id,
            solicitacao_idlogin: globalStore.idlogin,
            idlogin: globalStore.idlogin};
        const resp = await Api.genericPut('/cad/manut_os', payload);

        if (resp.bolok === 1) {
            closeForm();
        } else {
            msgAlerta.value = resp?.erro || 'Não foi possível encerrar digitação da OS';
        }
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


async function startPage(){
    await lerDados();
    if (lsDados.value.length === 0){msgAlerta.value = "Nenhuma solicitação aguardando orçamento"}
}

onMounted(startPage);
</script>

<style scoped>
.orc-preview {
    margin-top: 16px;
}

.orc-header {
    display: grid;
    grid-template-columns: repeat(4, minmax(120px, 1fr));
    gap: 8px 16px;
    padding: 12px;
    border: 1px solid #d8dee9;
    border-radius: 8px;
    background: #f8fafc;
    margin-bottom: 14px;
}

.orc-veiculo {
    grid-column: 1 / -1;
}

.orc-table-wrap {
    width: 100%;
    overflow-x: auto;
    border: 1px solid #d8dee9;
    border-radius: 8px;
}

.orc-table {
    width: 100%;
    min-width: 1050px;
    border-collapse: collapse;
    font-size: 13px;
    background: #fff;
}

.orc-table th {
    background: #f1f5f9;
    font-weight: 600;
    text-align: left;
    padding: 8px;
    border-bottom: 1px solid #d8dee9;
}

.orc-table td {
    padding: 6px 8px;
    border-bottom: 1px solid #eef2f7;
    vertical-align: middle;
}

.orc-table tfoot td {
    background: #f8fafc;
    border-top: 1px solid #d8dee9;
}

.num {
    text-align: right;
    white-space: nowrap;
}

.orc-input-desc,
.orc-input-cod {
    width: 100%;
    border: 1px solid #d8dee9;
    border-radius: 5px;
    padding: 5px 7px;
    font-size: 13px;
    background: #fff;
}

.orc-input-desc {
    min-width: 280px;
}

.orc-input-cod {
    min-width: 90px;
}

.linha-alerta {
    background: #fff8e1;
}

.input-alerta {
    border-color: #f59e0b;
    background: #fffdf4;
}
</style>